module.exports = __webpack_public_path__ + "static/media/quote.74ebe986.svg";